module.exports = __webpack_public_path__ + "media/icons/ubezpieczenia@2x-44831058.png";